import { noop } from 'lodash';

export const defaultWidgetConfig = {
  iconBody: () => null,
  isActive: () => false,
  popoverBody: () => null,
  onClickHandler: noop,
};
